module.exports = __webpack_public_path__ + "img/reset_switch_step_3.0517d51d.gif";